import React from "react"
import { Input } from "reactstrap"
class InputColor extends React.Component {
  render() {
    return <Input {...this.props} type="color" />
  }
}

//value: string
//defaultValue: string
//onChange: value = string

export default InputColor
